import React from "react";
import { getClassName } from "@sscs/utils";
import styles from "./formGrid.module.scss";
const FormGrid = ({ children, className, }) => {
    return (React.createElement("div", { className: getClassName(styles.root, "form-grid", className) }, children));
};
export default FormGrid;
//# sourceMappingURL=FormGrid.js.map